// :cow: Cosmose CONFIDENTIAL :iso:
import { initialState } from '@med/app/home/campaign/modules/execution/store/execution.state';
import * as ExecutionActions from './execution.actions';

export function reducer(
  state = initialState,
  action: ExecutionActions.All,
) {
  switch (action.type) {
    case ExecutionActions.SET_ASSET_PACKAGES:
      return {
        ...state,
        assetPackages: action.payload.assetPackages,
      };
    case ExecutionActions.ADD_ASSET_PACKAGE:
      return {
        ...state,
        assetPackages: [...state.assetPackages, action.payload.assetPackage],
      };
    case ExecutionActions.UPDATE_ASSET_PACKAGE: {
      const packageIndex = state.assetPackages.findIndex(assetPackage => assetPackage.id === action.payload.assetPackage.id);
      const packages = state.assetPackages.slice();
      packages.splice(packageIndex, 1, action.payload.assetPackage);
      return {
        ...state,
        assetPackages: packages,
      };
    }
    case ExecutionActions.DELETE_ASSET_PACKAGE: {
      const packageIndex = state.assetPackages.findIndex(assetPackage => assetPackage.id === action.payload.assetPackageId);
      const packages = state.assetPackages.slice();
      packages.splice(packageIndex, 1);
      return {
        ...state,
        assetPackages: packages,
      };
    }
    default:
      return {...state};
  }
}
